import React from "react";

import { Props } from "./types";

function GroupIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="4.5 10 24 10">
      <path
        d="M3.466,9.183A2.311,2.311,0,1,0,1.155,6.872,2.313,2.313,0,0,0,3.466,9.183Zm16.177,0a2.311,2.311,0,1,0-2.311-2.311A2.313,2.313,0,0,0,19.643,9.183ZM20.8,10.338H18.487a2.3,2.3,0,0,0-1.628.672,5.282,5.282,0,0,1,2.712,3.95h2.383A1.154,1.154,0,0,0,23.109,13.8V12.649A2.313,2.313,0,0,0,20.8,10.338Zm-9.244,0A4.044,4.044,0,1,0,7.511,6.294,4.042,4.042,0,0,0,11.555,10.338Zm2.773,1.155h-.3a5.584,5.584,0,0,1-4.947,0h-.3a4.161,4.161,0,0,0-4.16,4.16v1.04a1.734,1.734,0,0,0,1.733,1.733h10.4a1.734,1.734,0,0,0,1.733-1.733v-1.04A4.161,4.161,0,0,0,14.328,11.494ZM6.25,11.01a2.3,2.3,0,0,0-1.628-.672H2.311A2.313,2.313,0,0,0,0,12.649V13.8A1.154,1.154,0,0,0,1.155,14.96h2.38A5.3,5.3,0,0,1,6.25,11.01Z"
        transform="translate(4.945 5.573)"
      />
    </svg>
  );
}

export { GroupIcon };
